import { render } from "./BorrowerAddress.vue?vue&type=template&id=435abd7c"
import script from "./BorrowerAddress.vue?vue&type=script&lang=js"
export * from "./BorrowerAddress.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__